import { render, staticRenderFns } from "./BubbleListFooter.vue?vue&type=template&id=e34b9870&scoped=true"
import script from "./BubbleListFooter.vue?vue&type=script&lang=js"
export * from "./BubbleListFooter.vue?vue&type=script&lang=js"
import style0 from "./BubbleListFooter.vue?vue&type=style&index=0&id=e34b9870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e34b9870",
  null
  
)

export default component.exports